const BASE_QUERY_KEY=["UserPreferences"];export const USER_PREFERENCES_QUERY_KEYS={userPreferences:[...BASE_QUERY_KEY,"Base"]};